import styled from 'styled-components';

export default styled.div`
  display: ${({block}) => block ? 'block' : 'inline-block'};
  opacity: 0.5;
  font-family: 'Graphik LC', sans-serif;
  font-size: 10px;
  text-align: center;
  text-transform: uppercase;
  color: ${({color}) => color ? color : '#151515'};
  white-space: nowrap;
  line-height: 1.8;
`;